import React from 'react'
import Loadding from '../Loadding'

interface IProps {
  className: string
  onClick(): void
  children: React.ReactNode
  loading?: boolean
  disabled?: boolean
}

export default function Index({ className, onClick, loading = false, disabled = false, children }: IProps) {
  return (
    <button
      onClick={!loading && !disabled ? onClick : () => {}}
      disabled={disabled}
      className={`relative hover:scale-105 hover:cursor-pointer active:scale-95 transition ${disabled ? 'cursor-no-drop' : ''} ${className}`}
    >
      <Loadding state={loading} loaderClassName="border-[#ededed]">
        {children}
      </Loadding>
    </button>
  )
}
